module.exports = __webpack_public_path__ + "img/mineral-1.5387783b.png";